<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <section>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.sponsor_name"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Tag Line</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="tagline"
                  class="w-full"
                  v-model="form.sponsor_tagline"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('tagline')"
                  >{{ errors.first("tagline") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Booth ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="booth_id"
                  class="w-full"
                  v-model="form.booth_id"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('booth_id')"
                  >{{ errors.first("booth_id") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Logo</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                 <vs-input
                  type="file"
                  ref="sponsor_logo"
                  name="sponsor_logo"
                  class="w-full"
                  v-model="form.sponsor_logo"
                  @change="setLogo"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('sponsor_logo')"
                  >{{ errors.first("sponsor_logo") }}</span
                >
              </div>
            </div>
          </section>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Create</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";
import { timezones } from "@/utils/Timezones";
import { currencyList } from "@/utils/Constants";

const dict = {
  form: {
    name: {
      required: "Please enter an event name",
    },
    slug: {
      required: "Please enter your last name",
      alpha: "Your last name may only contain alphabetic characters",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
export default {
  components: {},
  data: () => ({
    suffixParams:'',
    timezones: timezones,
    valid: true,
    file:{
      sponsor_logo:null
    },
    form: {
      sponsor_filter: null,
      slug: null,
      sponsor_name: null,
      sponsor_tagline: null,
      company_id: null,
      booth_id: null,
      publish_status: true,
      listing_status: true,
      weight: 100,
      sponsor_remark: null,
      sponsor_logo:null
    },
  }),
  created(){
    setTimeout(()=>{
      this.suffixParams = "?s=" + this.$route.query.s + "&e=" + this.$route.query.e
    }, 1000)
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
      };

      this.form.slug = this.slug(
        this.form.sponsor_name + " " + this.generateNumber()
      );

      this.form = { ...this.form, ...data };

      this.$vs.loading();
      Service.Sponsor.create(this.form)
        .then((res) => {
          if (res.success) {

            this.doUploadFile(res.data.sponsor.sponsor_id)
          
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    doUploadFile(id){
      var formData = new FormData();
      formData.append('e', this.$route.query.e);

      if(this.file.sponsor_logo!=null){
          formData.append('sponsor_logo', this.file.sponsor_logo);
      }
      
      Service.Sponsor.upload(id, formData).then(res=>{
        if(res.success){
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          this.$router.push("/conferences/sponsors"+this.suffixParams);
        }
      })
    },
    setLogo(e){
      this.file.sponsor_logo = e.target.files[0];
    },
    slug(word) {
      let resp = word
        .toLowerCase() // LowerCase
        .replace(/\s+/g, "-") // space to -
        .replace(/&/g, `-and-`) // & to and
        .replace(/--/g, `-`); // -- to -
      return resp;
    },
    generateNumber: function () {
      return Math.floor(Math.random() * (99999999 - 10000000 + 1) + 10000000);
    },
  },
};
</script>